import React, { useState } from "react";
import { Link } from "react-router-dom";
import ProfileModal from "../../ProfileModal";
import BuyerRfqRejectionModal from "./BuyerRfqRejectionModal";

export default function RFQTable({ loading, currentData, activeTab, formatDate, findTabConfig, editRequirementData }) {
  const [showProfile, setShowProfile] = useState(false);
  const [companyId, setCompanyId] = useState(null);
  const [showBuyerRfqRejectionModal, setShowBuyerRfqRejectionModal] = useState(false);
  const [selectedRfq, setSelectedRfq] = useState(null);

  const tabConfig = findTabConfig(activeTab);
  const columns = tabConfig?.columns || [];

  if (loading) return <div>Loading...</div>;
  if (!currentData.length) return <div>No data found</div>;

  // Helper for formatting values dynamically
  const getValue = (item, col) => {
    switch (col.key) {
      case "companyName":
        return (
          <button
            type="button"
            onClick={() => {
              setCompanyId(item.companyId);
              setShowProfile(true);
            }}
            className="btn btn-link p-0 text-black text-decoration-underline"
          >
            {item[col.key]}
          </button>
        );
      case "buyerCompanyName":
        return (
          <button
            type="button"
            onClick={() => {
              setCompanyId(item.buyerCompanyId);
              setShowProfile(true);
            }}
            className="btn btn-link p-0 text-black text-decoration-underline"
          >
            {item[col.key]}
          </button>
        );
      case "requirementId":
        return (
          <Link
            to={`/seller-dashboard/detailed-rfq/${item._id}`}
            className="text-black underline"
          >
            {item.requirementId}
          </Link>
        );
      case "buyerRequirementId":
        return (
          <Link
            to={`/seller-dashboard/detailed-rfq/${item.requirementId}`}
            className="text-black underline"
          >
            {item.buyerRequirementId}
          </Link>
        );
      case "createdAt":
        return formatDate(item.createdAt) || "-";
      case "rfqCreatedAt":
        return formatDate(item.rfqCreatedAt) || "-";
      case "status":
        return (
          <span
            className="btn fw-semibold"
            style={{
              backgroundColor: "#F8F5FF",
              color: "#5014D0",
              borderRadius: "20px",
              padding: "4px 12px",
              fontSize: "0.85rem",
            }}
          >
            {item.status || "-"}
          </span>
        );
      case "action":
        return (
          <div className="d-flex">
            <button
              className="btn btn-sm d-flex align-items-center justify-content-center"
              onClick={() => {
                setSelectedRfq(item);
                setShowBuyerRfqRejectionModal(true)
              }}
            >
              <img
                src="/images/dislike.svg"
                alt="Dislike"
              />
            </button>
            <button
              className="btn btn-sm d-flex align-items-center justify-content-center"
              onClick={() =>
                editRequirementData({ ...item, status: "Seller Interested" })
              }
            >
              <img
                src="/images/like.svg"
                alt="Like"
              />
            </button>
          </div >
        );
      case "nda":
        return (
          <button
            className="btn btn-sm d-flex align-items-center justify-content-center"
          // onClick={() =>
          //   editRequirementData({ ...item, status: "Seller Signed NDA" })
          // }
          >
            <img
              src="/images/initiateNDA.svg"
              alt="Like"
            />
          </button>
        );
      case "discussion":
        return (
          <button
            className="btn btn-sm d-flex align-items-center justify-content-center"
          >
            <Link
              to={`/seller-dashboard/communication/${item?.groupChatId}`}
            >
              <img
                src="/images/discussion.svg"
                alt="Like"
              />
            </Link>
          </button >
        );
      default:
        return item[col.key] ?? "-";
    }
  };

  return (
    <div className="table-responsive border rounded">
      <table className="table align-middle table-bordered mb-0">
        <thead style={{ backgroundColor: "#FCFCFC" }}>
          <tr>
            {columns.map((col) => (
              <th key={col.key}>{col.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {currentData.map((item, idx) => (
            <tr key={item.requirementId || idx}>
              {columns.map((col) => (
                <td key={col.key}>{getValue(item, col)}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      <ProfileModal
        show={showProfile}
        companyId={companyId}
        onClose={() => setShowProfile(false)}
      />
      <BuyerRfqRejectionModal
        show={showBuyerRfqRejectionModal}
        rfq={selectedRfq}
        onConfirm={(reason) => {
          editRequirementData({ ...selectedRfq, status: "Seller Not Interested", rejectionReason: reason });
          setShowBuyerRfqRejectionModal(false);
          setSelectedRfq(null);
        }}
        onCancel={() => { setShowBuyerRfqRejectionModal(false); setSelectedRfq(null); }}
      />
    </div>
  );
}
